<template>
	<b-button
		id="ConvoItem"
		variant="outline"
		:disabled="active"
		:class="{ 'd-none': !visible,'human-need':convo && convo.needHumanFeedback ? convo.needHumanFeedback : '' }"
		@click="$emit('open', convo.id, prospect ? prospect.id : null)"
	>
		<div class="d-flex py-2 border-bottom">
			<!-- <div v-if="isOverDue" class="red_duetask_line" style="width: 1em; height:2em" /> -->
			<div class="plforUI position-relative" style="width: 3em">
				<!-- <h6>{{convo.Unread > 0}}  {{!convo.Unread}}</h6> -->

				<!-- <h6>{{getUnreadMsgOrMail}} {{getUnreadMsgOrMailClass}}</h6> -->

				<b-button variant="outline" :disabled="convo.Unread > 0" class="dot-btn center p-0 alarm-grey" @click.stop.prevent="markUnread" pill>
					<div :class="{ 'read': !convo.Unread }" class="rounded-circle blue" style="width: 1em; height:1em;" />
				</b-button>

				<!-- <b-button variant="outline" :disabled="getUnreadMsgOrMail" class="dot-btn center p-0 alarm-grey" @click.stop.prevent="markUnread" pill>
					<div :class="{ 'read':getUnreadMsgOrMailClass}" class="rounded-circle blue" style="width: 1em; height:1em;" />
				</b-button> -->
				<b-button v-if="convo.ScheduledCount" variant="outline"  class="alarm-btn">
					<v-icon  class="text-blue start-default" scale="2" name="clock" ></v-icon>
				</b-button>
				<!-- <b-button v-if="isOverDue" variant="outline" class="center p-0">
					<div class="red_duetask_line" style="width: 1em; height:1em" />
				</b-button> -->
			</div>
			<div class="flex-fill d-flex flex-column pr-2">
				<div class="d-flex justify-content-between" style="max-width: 300px;margin-left: auto;min-width: 300px;" >
					<div style="max-width: 70%">
						<h5 v-if="prospect" class="flex-fill before-icon d-flex-wrapper">{{$parseAlias(prospect)}}
							
							<span  
								v-if="isOverDue.val" 
								
								:class="getClassName"
								:id="prospect.id"
								
							>!</span>
							<b-popover
								:target="prospect.id"
								triggers="hover"
								placement="topright"
								container="my-container"
								ref="popover"
								custom-class="custom-popover"
								>
								<!-- <template #title>Task List</template> -->
								<!-- <div> -->
									<b-table-simple v-if="prospect.Tasks" bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
										<b-thead head-variant="light">
											<b-tr class="text-center">
												<b-th>Due Date</b-th>
												<b-th>Task</b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr
												:key="task.CreatedOn"
												class="text-left position-relative"
												style="font-size: 12px;"
												v-for="task of TaskList"
												:class="{'table-danger': task.Status == 'draft' && (task.DueOn <= Date.now())}"
											>
												<b-td>{{$parseDate(task.DueOn)}}</b-td>
												<b-td class="pr-5 position-relative">{{task.Description}}
													<b-button v-if="task.Status != 'compeleted'"
														style="right: 25px"
														variant="outline"
														class="center-vert"
														@click="compeleteTask(task)"
													>
														<v-icon class="text-blue" name="check" />
													</b-button>
													<b-button
														style="right: 0"
														variant="outline"
														class="center-vert"
														@click="removeTask(task)"
													>
														<v-icon class="text-blue" name="times" />
													</b-button>
												</b-td>
											</b-tr>
										</b-tbody>
									</b-table-simple>
								<!-- </div> -->
							</b-popover>
							<div v-if="!prospect.Starred" @click.stop.prevent="startMessage()">
								<v-icon :class="{ 'show_star': !prospect.Starred }" class="text-white start-default" scale="1" name="star" ></v-icon>
							</div>
							<span @click.stop.prevent="unStartMessage()" style="margin-left: 5px;">
								<v-icon v-if="prospect.Starred" class="text-blue start-default" scale="1" name="star" ></v-icon>
							</span>
							<span v-if="convo.Errors > 0" class="custom-error-text" v-b-popover.hover.top.html="'At least one message sent to candidate was undelivered'">Error</span>
						</h5>
						<h5 v-else class="flex-fill UIonlyNoShow">{{$parseNumber(convo.ClientNumber)}}</h5>
						<span id="message" style="color: gray" v-html="getConvertedText"></span>
					</div>
					<div style="text-align: end">
						<!-- <span v-if="isNotToday(convo.DateUpdated)">{{$parsePlainDate(convo.DateUpdated)}}</span><br/>
						<span>{{$parsePlainTime(convo.DateUpdated)}}</span><br/> -->
						<span class="convolistDate">{{$parseDate(convo.DateUpdated)}}</span><br/>
						<span v-if="prospect" style="color: gray; font-size: 14px;">{{prospect.Status}}</span><br/>
						<!-- <span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length && prospect.CciMap.Priority" style="color: gray">Priority: {{prospect.CciMap.Priority}}</span> -->
						<span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length" style="color: gray; font-size: 14px;">Priority: {{prospect.CciMap.Priority}}</span>
					</div>
				</div>
				
			</div>
		</div>
	</b-button>
</template>

<script>
	import { mapState } from 'vuex'
	import { db } from 'src/db'

	export default {
		name: "ConversationItem",
		props: {
			convo: {
				ClientNumber: String,
				LastMessage: String,
				DateUpdated: Number,
				Unread: Number,
				autoSms:Boolean,
				needHumanFeedback:Boolean
			},
			active: Boolean,
			filter: Number,
			isPriorityClicked:Boolean
		},
		computed: {
			getUnreadMsgOrMail() {
				let val = false;
				if (this.convo.Unread > 0 || this.convo.EmailUnread > 0 ) {
					val = true;
				}
				return val
			},
			getUnreadMsgOrMailClass() {
				let val = true;
				if (this.convo.Unread || this.convo.EmailUnread) {
					val = false;
				}
				return val
			},
			formattedMessage() {
				return this.convo.LastMessage && this.convo.LastMessage.length > 70 ?
						this.convo.LastMessage.substring(0, 70) + "..." :
						this.convo.LastMessage || "";
			},
			getConvertedText() {
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return this.formattedMessage.replace(urlRegex, function(url) {
					return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
				});
			},
			prospect() {
				for (let prospect of this.prospects) {
					if (prospect.Number == this.convo.ClientNumber) {
						return prospect;
					}
				}
				return null;
			},
			isOverDue() {
				let val = false;
				let taskType = '';
				let tmpTask = [];
				if(this.prospect && this.prospect.Tasks) {
					for (let task of this.prospect.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						taskType = 'gray';
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}else if (task.DueOn && task.Status == 'compeleted') {
							val = false;
							taskType = '';
						}else{
							val = true;
							taskType = 'gray';
						}
						// tmpTask[tmpTask.length] = taskType;
						tmpTask.push({ val: val, taskType });
					}
				}
				const containsRed = tmpTask.some(task => task.taskType === 'red');
				const containsYellow = tmpTask.some(task => task.taskType === 'yellow');
				const containsGray = tmpTask.some(task => task.taskType === 'gray');
				if (containsRed) {
					return { val: true, taskType: 'red' };
				} else if (containsYellow) {
					return { val: true, taskType: 'yellow' };
				} else if (containsGray) {
					return { val: true, taskType: 'gray' };
				} else {
					return { val: false, taskType: '' };
				}
			},
			isOverDueOldCode() {
				let val = false;
				let taskType = '';
				let tmpTask = [];
				if(this.prospect && this.prospect.Tasks) {
					for (let task of this.prospect.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						taskType = 'gray';
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}else if (task.DueOn && task.Status == 'compeleted') {
							val = false;
							taskType = '';
						}else{
							val = true;
							taskType = 'gray';
						}
						tmpTask[tmpTask.length] = taskType;
					}
				}
				if(tmpTask.includes('red')) {
					return {val,taskType:"red"}		
				}else if(tmpTask.includes('yellow')) {
					return {val,taskType:"yellow"}
				}else{
					return {val,taskType}
				}
			},
			isOverDueOldLogic() {
				let val = false;
				let taskType = '';
				if(this.prospect && this.prospect.Tasks) {
					for (let task of this.prospect.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
							break;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}
						else if (task.DueOn && task.Status == 'draft') {
							val = true;
							taskType = 'gray';
						}
					}
				}
				return {val,taskType}
			},
			TaskList() {
				let unCompeletedTaskList = [];
				for (let task of this.prospect.Tasks) {
					var someDate = new Date();
					someDate.setDate(someDate.getDate() + 3);
					// if (task.DueOn && task.Status == 'draft' && ((task.DueOn <= (someDate.getTime()) && task.DueOn >=  Date.now() || task.DueOn <= Date.now()))) {
					// 	unCompeletedTaskList.push(task)
					// }
					// unCompeletedTaskList.push(task)
					if (task.DueOn && task.Status == 'draft') {
						unCompeletedTaskList.push(task)
					}
				}
				return unCompeletedTaskList;
			},
			
			visible() {
				if (this.filter == -1) {
					return this.prospect && this.prospect.Status == 'Archived';
				}
				let numFolders = this.user.Folders ? this.user.Folders.length : 0;
				let iFolder = this.filter - 9;
				let iStage = this.filter - numFolders - 9;
				if (!this.isPriorityClicked) {
					if (iStage >= 0) {
						return this.prospect && this.prospect.Status == this.user.Stages[iStage];
					}
					if (iFolder >= 0) {
						return this.prospect && this.prospect.hasOwnProperty('Tags') && this.prospect.Tags && this.prospect.Tags.includes(this.user.Folders[iFolder]);
					}
				}else {
					return this.prospect
				}
				return !this.prospect || this.prospect.Status != 'Archived';
			},
			getClassName() {
				let cname = '';
				if (this.isOverDue.taskType == 'yellow') {
					cname = 'yellow'
				}else if(this.isOverDue.taskType == 'gray') {
					cname = 'gray'
				}else if (this.isOverDue.taskType == 'red') {
					cname = 'red'
				}
				return cname;
			},
			...mapState('globals', ['startCount','unreadCountTotal']),
			...mapState('firebase', ['user', 'prospects'])
		},
		methods: {
			isNotToday(milliseconds) {
				let date = new Date(parseInt(milliseconds));
				let now = new Date();
				if (date.getFullYear() === now.getFullYear() &&
					date.getMonth() === now.getMonth() &&
					date.getDate() === now.getDate()) {
					return false;
				}
				return true;
			},
			async markUnread() {
				await db.doc(`Conversations/${this.convo.id}`).update({Unread: 1});
				this.$store.commit('globals/SET', { var: 'unreadCountTotal', val: this.unreadCountTotal-1 });
				this.$store.dispatch('firebase/rebindConvosUnreadCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			commonCreateNotes(notesAdd) {
				var notesArray1 = [];
				var nt = [];
                Object.assign(nt,this.prospect.Notes) ;
				if(this.prospect.hasOwnProperty('Notes') && nt != null || nt != undefined) {
					notesArray1 = nt;
				}
				let notesArray2 = [{
					'date': Date.now(),
					'description': notesAdd,
					'mediaURL': ''
				}];
				let notesFinalArray = [...notesArray1, ...notesArray2];
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Notes: notesFinalArray })
				.catch(err => {
					this.$emit('error', err);
				});
			},
			compeleteTask(key) {
				if (confirm("Are you sure you want to mark this task as completed?")) {
					// let i=0;
					let taskDesc = '';
					for (let t of this.prospect.Tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							// this.prospect.Tasks.splice(i,1)
							t.Status = 'compeleted';
							t.CompletedOn = Date.now();
							// this.prospect.Tasks.splice(i,1)
							taskDesc = t.Description;
						}
						// i++;
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Tasks:this.prospect.Tasks});
					let noteMsg = "Task "+ taskDesc + " was completed";
					this.commonCreateNotes(noteMsg);
					/*
					let noteList = this.prospect.Notes;
					let firstNote = {};
					if (!noteList) {
						firstNote[Date.now()] = noteMsg;
					} else if (Object.keys(noteList).length > 0) {
						noteList[Date.now()] = noteMsg;
						firstNote = noteList;
					} else {
						firstNote[Date.now()] = noteMsg;
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Notes:firstNote});
					*/
				}
			},
			removeTask(key) {
				if (confirm("Are you sure you want to delete this task?")) {
					let i=0;
					for (let t of this.prospect.Tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							this.prospect.Tasks.splice(i,1)
						}
						i++;
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Tasks:this.prospect.Tasks});
					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));
					this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: overdueProspects.length });
				}
			},
			startMessage() {
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:true});
				this.$store.dispatch('firebase/rebindConvosStarredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			unStartMessage() {
				// let starred = true;
				// if (this.prospect.hasOwnProperty('Starred') && this.prospect.Starred) {
				// 	starred = false
				// }
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:false});
				this.$store.dispatch('firebase/rebindConvosStarredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			}
		},
		data(){
			return{
				isBasichumanNeed:true
			}
		}
	}
</script>

<style scoped>
/*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
	#ConvoItem {
		width: 100%;
		padding: 0;
		text-align: left;
		border: 0;
		background-color: white;
		margin:1px 0px;
	}
	#ConvoItem:disabled {
		background-color: #E0E0E0 !important;
	}
	#ConvoItem.human-need{
		background-color: #FAFAAF !important;
	}
	#ConvoItem.human-need:disabled {
		background-color: #FAFAAF !important;
	}
	#ConvoItem:hover {
		background-color: #F8F8F8;
	}
	#message {
		font-size: 12px;
	}
	.read {
		background-color: transparent;
	}
	.read:hover {
		background-color: rgba(4,43,121,.3);
	}
	.show_star {
		background-color:  transparent;
	}
	.show_star:hover {
		background-color: transparent;fill: rgba(4,43,121,.3);
	}
	/* .red_duetask_line {
		border-left-color: red;
		border-left-style: solid;
		border-left-width: thick;
	} */
	.red {
	background-color: transparent;
	}
	.before-icon .red {
	font-size: 18px;margin-right: 5px;
	color: red;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
	}
	.before-icon .yellow {
	font-size: 18px;
	color:#ffc107;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
	}
	.before-icon .gray  {
		font-size: 18px;
		color:gray;
		font-weight: 800;
		object-fit: contain;
		object-position: center;
	}
	h5.flex-fill.before-icon {
	font-size: 14px;
	}
	.d-flex-wrapper{
		display: flex;align-items: baseline;
	}
	.start-default{
		width: 12px !important;height: 12px!important;display: inline-block;
	}
	.alarm-btn{
		padding: 0;
		height: 100%;
		display: flex;
		align-items: flex-end;
		justify-content: center;
		margin: auto;
		padding-bottom: 4px;
	}
	.dot-btn{
		padding-bottom: 15px !important;
	}
	.alarm-grey{
	background-color: transparent !important;
    border: none !important;
	}
	.convolistDate{
		font-size: 14px;
	}
	.UIonlyNoShow{
		font-size: 16px;
	}
	.custom-error-text{
		color: red; 
		font-weight: bold; 
		margin-left: 5px; 
		margin-top: -6px; 
		display: inline-block; 
		padding: 2px 5px; 
		background-color: #f8d7da; 
		border: 1px solid #f5c6cb; 
		border-radius: 4px;
	}
	.custom-popover{
		max-width: 300px !important;
		width: 300px !important;
	}
</style>
